import Table from 'components/Table';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { selectedCompanyStore } from 'stores/SelectedCompanyStore';
import _ from 'lodash';
import { generatePath, useNavigate } from 'react-router-dom';
import { routes } from 'components/Routes';
import { companyUsersStore } from 'stores/CompanyUsersStore';
import { RoleEnum } from 'types/RoleEnum';
import TrashButton from 'components/TrashButton';
import { UserInterface } from 'types/UserInterface';
import { companyRoleToString } from 'helpers/RoleHelper';
import { authStore } from 'stores/AuthStore';

const CompanyUsersTable = observer(() => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { selectedCompany } = selectedCompanyStore;

    useEffect(() => {
        if (selectedCompany) {
            companyUsersStore.getUsers(selectedCompany!.id);
        }

        return () => {
            companyUsersStore.resetStore();
        }
    }, [selectedCompany])

    const onDelete = (e: React.MouseEvent, companyId: string, userId: string) => {
        e.stopPropagation(); // Prevent table click from happening

        if (!window.confirm(t('confirmDelete')!)) return;
        companyUsersStore.deleteUser(companyId, userId);
    }

    const toggleRole = (e: React.MouseEvent, companyId: string, user: UserInterface) => {
        if (user.id === authStore.user?.id) return;

        e.stopPropagation(); // Prevent table click from happening

        const companyUser = _.find(user.companies, c => c.company.id === companyId);
        if (!companyUser) return '';

        let newRole: RoleEnum;
        if (companyUser.role === RoleEnum.BLOCKED) {
            newRole = RoleEnum.USER;
        }
        else if (companyUser.role === RoleEnum.USER) {
            newRole = RoleEnum.ADMIN
        }
        else {
            newRole = RoleEnum.BLOCKED;
        }

        companyUsersStore.updateUserRole(companyId, user.id, newRole);
    }

    const users = _.orderBy(companyUsersStore.users, u => u.name?.toLowerCase());

    return (
        <Table
            defaultSortLabel='name'
            data={users}
            render={[
                {
                    label: t('name'),
                    cell: (item) => item.name,
                    sortProperty: (item) => item.name
                },
                {
                    label: t('email'),
                    cell: (item) => item.email,
                    sortProperty: (item) => item.email
                },
                {
                    label: t('role'),
                    cell: (item) => {
                        const company = _.find(item.companies, c => c.company.id === selectedCompany!.id);
                        if (!company) return '';

                        return (
                            <div
                                className={`cursor-pointer ${item.id === authStore.user?.id ? '' : 'underline'}`}
                                onClick={(e) => toggleRole(e, selectedCompany!.id, item)}>
                                {companyRoleToString(company.role)}
                            </div>
                        )
                    },
                    sortProperty: (item) => {
                        const company = _.find(item.companies, c => c.company.id === selectedCompany!.id);
                        if (!company) return '';
                        return companyRoleToString(company.role);
                    },
                },
                {
                    label: '',
                    width: '70',
                    cell: (item) => {
                        return (
                            <div onClick={(e) => onDelete(e, selectedCompany!.id, item.id)}>
                                <TrashButton />
                            </div>
                        )
                    }
                }
            ]}
        />
    )

})

export default CompanyUsersTable;